import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/layouts/error.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/app/layouts/landing.vue").then(m => m.default || m)),
  unsigned: defineAsyncComponent(() => import("/app/layouts/unsigned.vue").then(m => m.default || m))
}